import React from 'react';
import PropTypes from 'prop-types';

const CompanyFieldPreview = ({ field, companyFieldList }) => {
  const selectedCompanyField = companyFieldList.find(
    (f) => f._id === (field.properties?.basicProperties?.companyFieldId ?? ''),
  );

  return (
    <div className='border-grey-1-h-1 rounded-sm d-flex justify-content-center align-items-center p-2'>
      <label>{selectedCompanyField?.fieldTitle ?? 'Select company field'}</label>
    </div>
  );
};

CompanyFieldPreview.propTypes = {
  field: PropTypes.object.isRequired,
  companyFieldList: PropTypes.array.isRequired,
};

export default CompanyFieldPreview;
